export default {
    getPatientCount(study) {
        return window._.sumBy(study.patientEnrollments.filter((pe) => pe.includeInEnrollmentCount), (pe) => window._.toNumber(pe.value));
    },
};
